import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import classnames from 'classnames';
import { eachYearOfInterval, isSameYear, format, startOfYear, endOfYear } from 'date-fns';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { useIntervalPicker } from './useIntervalPicker.js';
import { makeYearsInterval } from './utils.js';
import { s as styles } from './date-picker-DxEXPS6T.js';
import 'react';
import 'date-fns/constants';

const YEARS_IN_ROW = 3;
const YearPicker = ({ displayDate, selectedDate, onDateSelect }) => {
    const dates = eachYearOfInterval(makeYearsInterval(displayDate));
    const forceDisabled = useDisabled();
    return (jsx("div", { className: classnames(styles.calendar, styles.calendarYears), "data-qa": "date-picker-years", children: dates.map((date) => {
            const isSelected = !!selectedDate && isSameYear(date, selectedDate);
            return (jsx("div", { className: styles.item, children: jsx("button", { className: classnames(styles.text, {
                        [styles.textDisabled]: forceDisabled,
                        [styles.textSelected]: isSelected,
                        [styles.textToday]: isSameYear(date, Date.now()),
                        [styles.textUnselected]: !forceDisabled && !isSelected,
                    }), onClick: () => onDateSelect?.(date), children: format(date, 'yyyy') }) }, `${date}`));
        }) }));
};
const IntervalYearPicker = ({ displayDate, selectionStart, selectionEnd, onStartSelect, onEndSelect, }) => {
    const dates = eachYearOfInterval(makeYearsInterval(displayDate));
    const datesProps = useIntervalPicker({
        dates,
        selectionStart: selectionStart && startOfYear(selectionStart),
        selectionEnd: selectionEnd && endOfYear(selectionEnd),
        onStartSelect,
        onEndSelect,
        isEqual: isSameYear,
    });
    return (jsx("div", { className: classnames(styles.calendar, styles.calendarYears), "data-qa": "date-picker-years", children: eachYearOfInterval(makeYearsInterval(displayDate)).map((date, index) => {
            const { isDisabled, isIntervalStart, isIntervalEnd, isSelected, isWithinInterval, mouseHandlers } = datesProps[index];
            const isIntervalRowStart = isWithinInterval && !isIntervalStart && index % YEARS_IN_ROW === 0;
            const isIntervalRowEnd = isWithinInterval && !isIntervalEnd && index % YEARS_IN_ROW === YEARS_IN_ROW - 1;
            return (jsxs("div", { className: classnames(styles.item, {
                    [styles.itemInterval]: isWithinInterval,
                    [styles.itemIntervalStart]: isIntervalStart,
                    [styles.itemIntervalEnd]: isIntervalEnd,
                    [styles.itemIntervalRowStart]: isIntervalRowStart,
                    [styles.itemIntervalRowEnd]: isIntervalRowEnd,
                }), children: [jsx("button", { ...mouseHandlers, className: classnames(styles.text, {
                            [styles.textDisabled]: isDisabled,
                            [styles.textSelected]: isSelected,
                            [styles.textToday]: isSameYear(date, Date.now()),
                            [styles.textUnselected]: !isDisabled && !isSelected,
                        }), children: format(date, 'yyyy') }), isWithinInterval && jsx("div", { className: styles.substrate })] }, `${date}`));
        }) }));
};

export { IntervalYearPicker, YearPicker };
//# sourceMappingURL=YearPicker.js.map
